import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {textRequestBuilder} from '~/utils/foundry';

import './index.scss';

const propTypes = {
  options: PropTypes.shape({
    color: PropTypes.shape({
      cssString: PropTypes.string
    }),
    fontHeight: PropTypes.number,
    sizeIsDirty: PropTypes.bool,
    value: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  handleError: PropTypes.func,
  scale: PropTypes.number,
  selectedViewScaleFactor: PropTypes.number,
  onRender: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class FoundryImage extends Component {
  static displayName = 'FoundryImage';

  static propTypes = propTypes;

  static defaultProps = {
    handleError() {},
    onRender() {}
  };

  state = {
    imageSrc: textRequestBuilder(
      this.props.options,
      this.props.scale,
      'gen',
      this.props.selectedViewScaleFactor
    ),
    error: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      imageSrc: textRequestBuilder(
        nextProps.options,
        nextProps.scale,
        'gen',
        this.props.selectedViewScaleFactor
      ),
      error: false
    });
  }

  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null;
      this.img.onerror = null;
    }
  }

  img = null;

  handleRequestSuccess = e => {
    this.setState({error: false});
    this.props.onRender(e.target);
  };

  handleRequestError = err => {
    this.setState({error: true});
    this.props.handleError(err.nativeEvent);
  };

  render() {
    const options = this.props.options;
    const {color} = options;
    if (this.state.error) {
      const fallback = {
        color: color.cssString,
        fontSize: options.fontHeight * this.props.scale
      };
      return (
        <div className="ndx-FoundryImage" style={fallback}>
          {options.value}
        </div>
      );
    }
    return (
      <img
        className="ndx-FoundryImage"
        draggable={false}
        src={this.state.imageSrc}
        onError={this.handleRequestError}
        onLoad={this.handleRequestSuccess}
      />
    );
  }
}
